export default {
    url: '/results',
    // TODO ::  COUR-1281 - use this template to move on
    template: '<quiz-finished show-points-awarded="true" form-submission="vm.formSubmission"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            // TODO :: consider reducing shown fields, all fields should not be seen by another person
            if (!$stateParams.guid) {
                return false;
            }
            return FormSubmissionResource.get({ guid: $stateParams.guid, expand: 'form,trainingActiveI18n,occurrenceTraining,trainingProgress,formSubmissionAnswers.question' }).$promise;
        },
        company (CompanyResource, formSubmission) {
            return CompanyResource.publicView({ id: formSubmission.companyId }).$promise;
        }
    },
    controller (formSubmission, company, CompanyService) {
        if (company.skin) {
            CompanyService.loadSkin(company.skin);
        }

        this.formSubmission = formSubmission;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/quiz/results/index.js